import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Richtungspfeil", -1),
    _createElementVNode("path", {
      d: "M100.03 180.97V20.94l56.68 56.89 5.67-5.65L98.92 8.5a4.01 4.01 0 0 0-2.83-1.18c-1.06 0-2.08.42-2.83 1.17l-63.6 63.62 5.66 5.66 56.71-56.73v159.93z",
      style: {"fill":"#2d2d2d"}
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "up"}) } }